import * as Funciones from "../../utils/funciones";

export const mapDataToCuestionario = (asegurado, productos, esAPFamiliar, conyuge, hijos, fumador) => {
    return {
        nombres                : asegurado.nombres,
        apellidos              : asegurado.apellidoPaterno + ' ' + asegurado.apellidoMaterno,
        fechaInicio            : Funciones.obtenerFechaHoy(),
        fechaNacimiento        : `${Funciones.formatearFechaTextoFormat(asegurado.fechaNacimiento)}`,
        genero                 : asegurado.sexo.codigo === 1 ? 'Male' : 'Female',
        producto               : productos,
        fechaNacimientoConyuge : esAPFamiliar === true && conyuge.fechaNacimiento !== undefined
            ? Funciones.formatearFechaTextoFormat(conyuge.fechaNacimiento)
            : null,
        fechaNacimientoHijos   : esAPFamiliar === true && hijos !== undefined ? hijos : null,
        esFumador              : fumador,
        altura                 : null,
        peso                   : null
    }
}